import { api } from "../api";

export async function getMe() {
  return await api({ path: "settings", method: "GET" });
}
